const ORIENTATION_STATUS = Object.freeze({
  north: "North up",
  heading: "Heading up",
  course: "Course up",
  off: "Free"
})

function lngLat([lat, lon]) {
  return [lon, lat]
}

export function webOrientationCameraPlan({
  mode,
  tracking = false,
  orientation,
  bearing = null,
  lastFix = null,
  mapBearing = 0
} = {}) {
  if (!orientation) return { apply: false }

  const plan = {
    apply: true,
    orientation,
    renderOrient: true,
    status: ORIENTATION_STATUS[orientation] ?? null
  }

  if (orientation === "off") {
    if (mode === "following" && !tracking) plan.dispatch = "ORIENT_OFF"
    return plan
  }

  if (mode === "following" && lastFix) {
    plan.move = {
      target: { center: lngLat(lastFix), bearing: bearing ?? mapBearing },
      options: { duration: 400 }
    }
  } else if (bearing != null) {
    plan.move = {
      target: { bearing },
      options: { duration: 400 }
    }
  }

  return plan
}
